import React, { useState, useEffect } from "react";
import { Card, CardBody, FormGroup, Button, Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { FetchBannerImage, UpdateBannerImage } from "../../apis/Banner";

const BannerImage = () => {
  const [image, setImage] = useState(null); // for uploaded image
  const [fetchedImage, setFetchedImage] = useState(null); // for fetched image from API
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Bed", link: "#" },
  ];

  // Fetch the image from API when the component loads
  useEffect(() => {
    const getBannerImage = async () => {
      try {
        const bannerData = await FetchBannerImage();
        setFetchedImage(bannerData?.data.homePageSettings[0].bannerImageUrl); // Assuming the API returns image URL as 'image'
      } catch (error) {
        toast.error("Failed to fetch Banner image.");
      }
    };

    getBannerImage();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!image) {
      toast.error("Please select an image.");
      return;
    }

    try {
      const updatedBannerImage = await UpdateBannerImage(image);
      if (updatedBannerImage) {
        toast.success("Banner image Updated Successfully");
        navigate("/banner-image");
      }
    } catch (error) {
      toast.error("Banner image Update Failed");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file); // Set the uploaded image file
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Breadcrumbs title="Add Bed" breadcrumbItems={breadcrumbItems} />
          <Card>
            <CardBody>
              <h4 className="card-title">Banner Image</h4>
              <AvForm onSubmit={handleUpdate}>
                <div className="mb-3">
                  <AvField
                    name="image"
                    placeholder="Type Something"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    errorMessage="Please select an image"
                    validate={{ required: { value: true } }}
                  />
                </div>

                {/* Display the uploaded image */}
                {image && (
                  <div className="mb-3">
                    <h5>Uploaded Image Preview:</h5>
                    <img
                      src={URL.createObjectURL(image)}
                      alt="Uploaded Preview"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxWidth: "300px",
                      }}
                    />
                  </div>
                )}

                {/* Display the fetched image if no image is uploaded */}
                {!image && fetchedImage && (
                  <div className="mb-3">
                    <h5>Current Banner Image:</h5>
                    <img
                      src={fetchedImage}
                      alt="Current Banner"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxWidth: "300px",
                      }}
                    />
                  </div>
                )}

                <FormGroup className="mb-0">
                  <div>
                    <Button type="submit" color="primary" className="me-1">
                      Update
                    </Button>{" "}
                    <Button type="reset" color="secondary">
                      Cancel
                    </Button>
                  </div>
                </FormGroup>
              </AvForm>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BannerImage;
